export const EquipmentNoticeController = {
    index(): void {},
    show(): void {},
};
